import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import RequireAdmin from './components/RequireAdmin.jsx';
import Home from './pages/Home.jsx';
import Assistant from './pages/Assistant.jsx';
import ReportView from './pages/ReportView.jsx';
import DashboardView from './pages/DashboardView.jsx';
import WebsiteView from './pages/WebsiteView.jsx';
import SignInError from './pages/SignInError.jsx';
import PublicNotFound from './pages/PublicNotFound.jsx';
import Demo from './pages/Demo.jsx';
import AdminUsers from './pages/admin/Users.jsx';
import AdminProfiles from './pages/admin/Profiles.jsx';
import AdminCatalogue from './pages/admin/Catalogue.jsx';
import AdminPaginated from './pages/admin/Paginated.jsx';
import AdminAudit from './pages/admin/Audit.jsx';
import AdminAiSpend from './pages/admin/AiSpend.jsx';
import AdminUsage from './pages/admin/Usage.jsx';
import RequirePlatformAdmin from './components/RequirePlatformAdmin.jsx';
import PlatformCustomers from './pages/platform/Customers.jsx';

export default function App() {
  return (
    <Routes>
      <Route path="/error" element={<SignInError />} />
      {/* Public: a prospect has no session and no customer user record. */}
      <Route path="/demo" element={<Demo />} />
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="assistant" element={<Assistant />} />
        <Route path="report/:reportId" element={<ReportView kind="report" />} />
        <Route path="paginated/:reportId" element={<ReportView kind="paginated" />} />
        <Route path="dashboard/:dashboardId" element={<DashboardView />} />
        <Route path="site/:itemId" element={<WebsiteView />} />
        <Route element={<RequireAdmin />}>
          <Route path="admin/users" element={<AdminUsers />} />
          <Route path="admin/profiles" element={<AdminProfiles />} />
          <Route path="admin/catalogue" element={<AdminCatalogue />} />
          <Route path="admin/paginated" element={<AdminPaginated />} />
          <Route path="admin/audit" element={<AdminAudit />} />
          <Route path="admin/ai-spend" element={<AdminAiSpend />} />
          <Route path="admin/usage" element={<AdminUsage />} />
        </Route>
        <Route element={<RequirePlatformAdmin />}>
          <Route path="platform/customers" element={<PlatformCustomers />} />
        </Route>
      </Route>

      {/* Outside Layout on purpose: an unknown path may be visited by someone
          with no session, on a host with no customer. Redirecting to / sent
          them to a sign-in prompt, which is a dead end for a stranger. */}
      <Route path="*" element={<PublicNotFound />} />
    </Routes>
  );
}
